var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleOutsideClick,
          expression: "handleOutsideClick",
        },
      ],
      ref: "block_time_form",
      staticClass: "offcanvas offcanvas-right",
      attrs: { id: "block_time_form" },
    },
    [
      _c("button", {
        staticStyle: { display: "none" },
        attrs: { id: "block_time_form_toggle" },
      }),
      _c(
        "div",
        {
          staticClass:
            "offcanvas-header d-flex align-items-center justify-content-between pb-5",
        },
        [
          _c("h4", { staticClass: "font-weight-bold m-0" }, [
            _vm._v(" " + _vm._s(_vm.$t("blockTimeForm.title")) + " "),
          ]),
          _c(
            "a",
            {
              attrs: { href: "#", id: "block_time_form_close" },
              on: {
                click: function ($event) {
                  return _vm.closeOffcanvas("block_time_form")
                },
              },
            },
            [_c("i", { staticClass: "ki ki-close icon-md" })]
          ),
        ]
      ),
      _c(
        "perfect-scrollbar",
        {
          staticClass: "offcanvas-content mr-n5 scroll",
          staticStyle: { "max-height": "85vh", position: "relative" },
        },
        [
          _c(
            "div",
            {
              staticClass: "bb-date-input-value-container",
              on: { click: _vm.selectDate },
            },
            [
              _c(
                "span",
                {
                  staticClass: "bb-date-input-value",
                  class: this.form.fields.date ? "" : "success",
                },
                [_vm._v(_vm._s(_vm.selectedDateString))]
              ),
              _c("i", { staticClass: "la la-angle-right" }),
            ]
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.form.errors.date,
                  expression: "form.errors.date",
                },
              ],
              staticClass: "bb-invalid-feedback",
            },
            [_vm._v(" " + _vm._s(_vm.form.errors.date) + " ")]
          ),
          _c("hr"),
          _c(
            "div",
            { staticClass: "bb-form-group" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("blockTimeForm.staffInput.label"))),
              ]),
              _c("BBSelect", {
                attrs: {
                  options: _vm.staffOptions,
                  placeholder: _vm.$t("blockTimeForm.staffInput.placeholder"),
                  search: true,
                  searchPlaceholder: _vm.$t(
                    "blockTimeForm.staffInput.searchPlaceholder"
                  ),
                },
                scopedSlots: _vm._u([
                  {
                    key: "optionItem",
                    fn: function ({ option }) {
                      return [
                        _c("div", { staticClass: "badge-option-container" }, [
                          _c("div", { staticClass: "badge-option" }, [
                            _c("div", { staticClass: "bb-badge" }, [
                              _vm._v(" " + _vm._s(option.initials) + " "),
                            ]),
                            _c("div", { staticClass: "badge-option-text" }, [
                              _c("span", [_vm._v(_vm._s(option.text))]),
                              _c("small", [_vm._v(_vm._s(option.description))]),
                            ]),
                          ]),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "optionsFooter",
                    fn: function () {
                      return [
                        _vm.$hasRole(_vm.acl.roles.owner) ||
                        _vm.$hasPermission(_vm.acl.permissions.manageAccount) ||
                        _vm.$hasPermission(_vm.acl.permissions.managePlace)
                          ? _c("div", { on: { click: _vm.createCalendar } }, [
                              _c("i", { staticClass: "fas fa-plus" }),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("blockTimeForm.staffInput.createBtn")
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.form.fields.calendarId,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.fields, "calendarId", $$v)
                  },
                  expression: "form.fields.calendarId",
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.calendarId,
                      expression: "form.errors.calendarId",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.calendarId) + " ")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "d-flex justify-content-between pt-4" }, [
            _c(
              "div",
              { staticClass: "bb-form-group mr-2" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("blockTimeForm.startTimeInput.label"))),
                ]),
                _c("BBSelect", {
                  attrs: {
                    options: _vm.startTimeOptions,
                    placeholder: _vm.$t(
                      "blockTimeForm.startTimeInput.placeholder"
                    ),
                    noOptionsText: _vm.$t(
                      "blockTimeForm.startTimeInput.noResultsText"
                    ),
                  },
                  model: {
                    value: _vm.form.fields.from,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.fields, "from", $$v)
                    },
                    expression: "form.fields.from",
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.from,
                        expression: "form.errors.from",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [_vm._v(" " + _vm._s(_vm.form.errors.from) + " ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bb-form-group ml-2" },
              [
                _c("label", [
                  _vm._v(_vm._s(_vm.$t("blockTimeForm.endTimeInput.label"))),
                ]),
                _c("BBSelect", {
                  attrs: {
                    options: _vm.endTimeOptions,
                    placeholder: _vm.$t(
                      "blockTimeForm.endTimeInput.placeholder"
                    ),
                    noOptionsText: _vm.$t(
                      "blockTimeForm.endTimeInput.noResultsText"
                    ),
                  },
                  model: {
                    value: _vm.form.fields.to,
                    callback: function ($$v) {
                      _vm.$set(_vm.form.fields, "to", $$v)
                    },
                    expression: "form.fields.to",
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.form.errors.to,
                        expression: "form.errors.to",
                      },
                    ],
                    staticClass: "bb-invalid-feedback",
                  },
                  [_vm._v(" " + _vm._s(_vm.form.errors.to) + " ")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "bb-form-group" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("blockTimeForm.notesInput.label"))),
              ]),
              _c("b-form-textarea", {
                staticClass: "bb-textarea",
                attrs: {
                  placeholder: _vm.$t("blockTimeForm.notesInput.placeholder"),
                  rows: "4",
                },
                model: {
                  value: _vm.form.fields.notes,
                  callback: function ($$v) {
                    _vm.$set(_vm.form.fields, "notes", $$v)
                  },
                  expression: "form.fields.notes",
                },
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.errors.notes,
                      expression: "form.errors.notes",
                    },
                  ],
                  staticClass: "bb-invalid-feedback",
                },
                [_vm._v(" " + _vm._s(_vm.form.errors.notes) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "offcanvas-footer" }, [
        _c(
          "button",
          {
            staticClass: "bb-btn btn-success",
            on: {
              click: function ($event) {
                return _vm.submit()
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.submitButtonText) + " ")]
        ),
      ]),
      _c("CalendarFormModal", { ref: "calendarFormModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }